module.exports = __webpack_public_path__ + "static/splittable-preview-77deaee0260b876cdb7248da5e214ffc.png";